import React, { Fragment, useState, useEffect } from 'react';
import { FileDrop } from 'react-file-drop';
// Assets for banner page
import deleteIcon from '../../../assets/images/premiumService/Banner/delete.png';
import dropdownIcon from '../../../assets/images/premiumService/Banner/dropdown.png';
import uploadIcon from '../../../assets/images/premiumService/upload.png';
const IMG_URL = process.env.REACT_APP_IMAGE_ASSET_URL;


const BannerComponent = ({
    imageRef,
    isEdit,
    bannerImage,
    resetBanner,
    bannerName,
    setBannerName,
    bannerUrl,
    setBannerUrl,
    showSelectedImageNameFromEdit,
    handleFileChange,
    imageValidator,
    uploadImage,
    uploadedBannerImageData,
    createBanner,
    saveBannerAfterEdit,
    handlePremiumServiceOrBanner,
}) => {
    return (
        <Fragment>
            <div>
                {/* Title and Create Campaign Button Row */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <h4 style={{ color: '#333333', fontWeight: 'bold', margin: 0 }}>
                        {isEdit ? 'EDIT BANNER' : 'CREATE NEW BANNER'}
                    </h4>
                    <button 
                        onClick={() => handlePremiumServiceOrBanner('premium-service')}
                        style={{
                            backgroundColor: '#009900',
                            color: 'white',
                            border: '2px solid #009900',
                            borderRadius: '12px',
                            padding: '8px 16px',
                            fontWeight: 'bold',
                            cursor: 'pointer'
                        }}
                    >
                        Create New Campaign
                    </button>
                </div>

                {/* Main Container with Blue Border */}
                <div style={{ 
                    border: '2px solid #1395F2', 
                    borderRadius: '12px', 
                    padding: '30px',
                    backgroundColor: 'white',
                    boxShadow: '0 4px 12px rgba(19, 149, 242, 0.08), 0 2px 6px rgba(19, 149, 242, 0.04)',
                    marginBottom: '20px'
                }}>
                    {/* Banner Name */}
                    <div style={{ marginBottom: '20px' }}>
                        <input
                            className="campaign-input"
                            placeholder="Banner Name"
                            type="text"
                            onChange={(e) => setBannerName(e.target.value)}
                            value={bannerName}
                        />
                    </div>
                    {/* Upload Photo Section */}
                    <div style={{ marginBottom: '20px' }}>
                        <div style={{ marginBottom: '15px' }}>
                            <p style={{ fontSize: '18px', color: '#333333', marginBottom: '10px', fontWeight: 'bold' }}>
                                Upload Photo
                            </p>
                            <p style={{ fontSize: '14px', color: '#333333', marginBottom: '0' }}>
                                Image must be jpeg or png with resolution of 468x60 or 160x600
                            </p>
                        </div>
                        
                        {/* Upload Container with Green Border */}
                        <div style={{
                            border: '2px solid #009900',
                            borderRadius: '12px',
                            padding: '20px',
                            backgroundColor: '#f8fff8',
                            marginBottom: '15px'
                        }}>
                            {/* Inner Drag Drop Area */}
                            <div style={{
                                border: '2px dashed #009900',
                                borderRadius: '8px',
                                padding: '40px 20px',
                                textAlign: 'center',
                                backgroundColor: 'white',
                                marginBottom: '15px'
                            }}>
                                <FileDrop
                                    onDrop={(files, event) => {
                                        imageValidator(files[0])
                                    }}
                                >
                                    <p style={{ fontSize: '16px', color: '#333333', marginBottom: '15px', fontWeight: 'bold' }}>
                                        Drag Photo(s) here
                                    </p>
                                    {bannerImage && bannerImage.name && (
                                        <p style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
                                            {bannerImage.name}
                                        </p>
                                    )}
                                </FileDrop>
                                
                                <div style={{ margin: '15px 0' }}>
                                    <span style={{ 
                                        backgroundColor: 'white', 
                                        padding: '0 15px',
                                        color: '#666',
                                        fontSize: '14px',
                                        position: 'relative'
                                    }}>
                                        OR
                                    </span>
                                </div>
                                
                                <button
                                    style={{
                                        backgroundColor: '#009900',
                                        color: 'white',
                                        border: '2px solid #009900',
                                        borderRadius: '8px',
                                        padding: '8px 20px',
                                        fontWeight: 'bold',
                                        cursor: 'pointer',
                                        fontSize: '14px'
                                    }}
                                    onClick={() => imageRef.current?.click()}
                                >
                                    Choose File
                                </button>
                                
                                <input
                                    type="file"
                                    onChange={(e) => handleFileChange(e)}
                                    accept="image/*"
                                    ref={imageRef}
                                    style={{ display: 'none' }}
                                />
                            </div>
                            
                            {showSelectedImageNameFromEdit && (
                                <p style={{ marginBottom: '15px', fontSize: '14px', color: '#666' }}>
                                    {showSelectedImageNameFromEdit}
                                </p>
                            )}
                            
                            {uploadedBannerImageData && (
                                <p style={{ marginBottom: '15px', fontSize: '14px', color: '#333', fontWeight: 'bold' }}>
                                    Uploaded Banner Image: <span style={{ fontWeight: 'normal' }}>{uploadedBannerImageData}</span>
                                </p>
                            )}
                            
                            <button 
                                disabled={!bannerImage} 
                                onClick={uploadImage} 
                                style={{
                                    backgroundColor: bannerImage ? '#1395F2' : '#ccc',
                                    color: 'white',
                                    border: `2px solid ${bannerImage ? '#1395F2' : '#ccc'}`,
                                    borderRadius: '8px',
                                    padding: '8px 20px',
                                    fontWeight: 'bold',
                                    cursor: bannerImage ? 'pointer' : 'not-allowed',
                                    fontSize: '14px',
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px'
                                }}
                            >
                                <img 
                                    src={uploadIcon} 
                                    alt="Upload" 
                                    style={{ width: 16, height: 16, filter: 'brightness(0) invert(1)' }} 
                                />
                                Upload
                            </button>
                        </div>
                    </div>
                    {/* URL Input */}
                    <div style={{ marginBottom: '30px' }}>
                        <input
                            className="campaign-input"
                            placeholder="URL"
                            type="text"
                            onChange={(e) => setBannerUrl(e.target.value)}
                            value={bannerUrl}
                        />
                    </div>

                    {/* Action Buttons */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px' }}>
                        <button
                            disabled={!bannerImage || !bannerUrl || !bannerName}
                            onClick={isEdit ? saveBannerAfterEdit : createBanner}
                            style={{
                                backgroundColor: (!bannerImage || !bannerUrl || !bannerName) ? '#ccc' : '#009900',
                                color: 'white',
                                border: `2px solid ${(!bannerImage || !bannerUrl || !bannerName) ? '#ccc' : '#009900'}`,
                                borderRadius: '12px',
                                width: '180px',
                                height: '45px',
                                fontWeight: 'bold',
                                cursor: (!bannerImage || !bannerUrl || !bannerName) ? 'not-allowed' : 'pointer'
                            }}
                        >
                            Save Banner
                        </button>
                        <button 
                            onClick={resetBanner}
                            style={{
                                backgroundColor: 'white',
                                color: '#1395F2',
                                border: '2px solid #1395F2',
                                borderRadius: '12px',
                                width: '180px',
                                height: '45px',
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                        >
                            Reset
                        </button>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
export default BannerComponent;